<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="room?.name ? room?.name : ''"
      [canGoBack]="true"
      [customBack]="'to-dos'"
      [showLinkIcon]="true"
      [linkIcon]="'trash'"
      (linkAction)="deleteGroup()" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper (contentHeight)="contentHeight = $event" class="fab-page">


    @if (loaded) {
      @if (errorMessage?.length) {
        <tidy-error-message
          [text]="errorMessage" />
      }
      <tidy-card class="no-padding">
        <tidy-card-button
          class="arrow-to-top no-padding"
          [customArrowPositon]="{ top: '18px', right: '15px' }"
          (action)="goToEditRoomInfo()">
          <tidy-row class="vertical-align-center extra-bottom-padding extra-top-padding extra-left-padding extra-right-padding">
            <tidy-text
              [header]="'Card Info'" />
          </tidy-row>
          </tidy-card-button>
          <div class="slide-container">
            @if (room?.photos?.length > 0) {
              <tidy-carrousel
                [scaleImages]="true"
                class="photo-notes-carrousel only-padding-bottom"
                >
                @for (photoNote of room?.photos; track photoNote) {
                  <tidy-photo-note
                    class="full-width there-is-carrousel no-margin"
                    *tidyCarrousel
                    [caption]="photoNote.photo_note_caption"
                    [src]="photoNote.photo_url"
                  />
                }
              </tidy-carrousel>
            }
          </div>
        </tidy-card>
        @if (isRightSideContent) {
          <tidy-row [align]="'center'">
            <tidy-text
              [body]="'Delete Card'"
              (action)="deleteGroup()"
              class="red link" />
          </tidy-row>
        }
        @if (room?.tasks?.length > 0) {
          <tidy-row [alignLastItemRight]="true" class="extra-top-padding" style="margin-bottom: 0px;">
            <tidy-row [alignLastItemRight]="true" class="full-width">
              <tidy-text
                [header]="'Checklist Items'" />
              <tidy-text
                [body]="'Edit Priorities'" />
            </tidy-row>
            <tidy-toggle [toggled]="editPrio" (toggleChanged)="editPrio = !editPrio" class="extra-left-margin" />
          </tidy-row>
        }
        @if (room?.tasks?.length === 0) {
          <tidy-row [align]="'center'">
            <tidy-text
              [body]="'No checklist items added in'" /><span>&nbsp;</span>
              <tidy-text
                [body]="room?.name + '.'"
                [translate]="false" />
            </tidy-row>
          }
          @if (room?.tasks?.length !== 0) {
            <tidy-drag-drop
              dragDropId="favorites-dd"
              [dataList]="room?.tasks"
              emptyListColor="green"
              emptyDisabledListMessage="No checklist items added"
              [disabled]="!editPrio"
              (listDropped)="updateToDoOrder($event)">
              @for (toDo of room?.tasks; track toDo) {
                <ng-container *tidyDragDropItem>
                  <tidy-card class="no-padding">
                    @if (!toDo?.task_type?.includes('video')) {
                      <tidy-card-button
                        class="arrow-to-top no-padding"
                        [hideArrow]="editPrio"
                        (action)="editPrio ? '': goToEditToDo(toDo)"
                        
                        [customArrowPositon]="{ top: '15px', right: '15px' }">
                        <tidy-row class="extra-bottom-padding extra-top-padding extra-left-padding extra-right-padding" [ngStyle]="editPrio ? {'padding-bottom' : '15px'} : ''">
                          <span [ngStyle]="toDos.important(toDo?.is_important)" class="vertical-align-center" style="width: fit-content">
                            @if (editPrio) {
                              <tidy-image
                                [src]="'assets/svg/menu-tidy-green.svg'"
                                class="title-size" />
                            }
                            @if (toDo?.is_important && !editPrio) {
                              <tidy-image
                                [src]="'assets/img/star.svg'"
                                class="body-size position-absolute" />
                            }
                            <tidy-text
                              [class.padding-left-20]="toDo?.is_important"
                              [header]="toDo?.title"
                              [translate]="false" />
                          </span>
                        </tidy-row>
                        @if (!editPrio) {
                          @if (toDo?.note !== '' && toDo?.note !== null) {
                            <tidy-row class="vertical-align-center extra-left-padding extra-right-padding extra-bottom-padding">
                              <tidy-image
                                [src]="'assets/img/notes.svg'"
                                class="body-size" />
                              <tidy-markdown [markdownContent]="toDo?.note" />
                            </tidy-row>
                          }
                          @if (toDo?.room_object) {
                            <tidy-row class="vertical-align-middle extra-left-padding extra-right-padding extra-bottom-padding">
                              <img
                                [src]="toDo?.room_object?.model?.category?.default_icon_url"
                                style="width:16px; margin-right: 5px; margin-bottom: -3px">
                              <tidy-text
                                [body]="toDo?.room_object?.name"
                                [translate]="false" />
                              @if (toDo?.room_object?.min_quantity) {
                                <span>&nbsp;</span>
                                <tidy-text
                                  [body]="'(notify if count < '" />
                                <tidy-text
                                  [body]="toDo?.room_object?.min_quantity + ')'" />
                              }
                            </tidy-row>
                          }
                          @if (toDo?.options?.length > 0) {
                            <tidy-row class="extra-bottom-padding extra-left-padding extra-right-padding">
                              <tidy-divider />
                            </tidy-row>
                            <tidy-row class="extra-left-padding extra-right-padding extra-bottom-padding">
                              <tidy-text
                                [body]="'Custom Fields:'" />
                            </tidy-row>
                            @for (field of toDo?.options; track field) {
                              <tidy-row class="extra-left-padding extra-right-padding extra-bottom-padding vertical-align-middle">
                                <tidy-image
                                  [src]="toDos.getCustomFieldIcon(field?.name)"
                                  class="header-size" />
                                <tidy-text
                                  [body]="field?.name + ': ' + field?.notes + (field?.allowed_values?.length > 0 ? ': ' : '')" />
                                @for (option of field?.allowed_values; track option; let last = $last) {
                                  <tidy-text
                                    [body]="option + (last ? '' : ', ')" />
                                }
                              </tidy-row>
                            }
                          }
                        }
                      </tidy-card-button>
                      @if (!editPrio) {
                        <div class="slide-container">
                          @if (toDo?.photo_notes?.length > 0) {
                            <tidy-carrousel
                              [scaleImages]="true"
                              class="photo-notes-carrousel only-padding-bottom">
                              @for (photoNote of toDo?.photo_notes; track photoNote) {
                                <tidy-photo-note
                                  class="full-width there-is-carrousel no-margin"
                                  *tidyCarrousel
                                  [caption]="photoNote.photo_note_caption"
                                  [src]="photoNote.photo_url"
                                />
                              }
                            </tidy-carrousel>
                          }
                        </div>
                      }
                    }
                  </tidy-card>
                </ng-container>
              }
            </tidy-drag-drop>
          }
        }

        @if (!loaded) {
          <tidy-card>
            <tidy-row>
              <ion-skeleton-text animated="true" style="width: 38%; height: 16px" />
            </tidy-row>
            <tidy-row>
              <ion-skeleton-text animated="true" style="width: 24%" />
            </tidy-row>
          </tidy-card>
          <tidy-row>
            <ion-skeleton-text animated="true" style="width: 50%; margin: auto" />
          </tidy-row>
          <tidy-card>
            <tidy-row>
              <ion-skeleton-text animated="true" style="width: 42%; height: 16px" />
            </tidy-row>
            <tidy-row>
              <ion-skeleton-text animated="true" style="width: 24%" />
            </tidy-row>
          </tidy-card>
          <tidy-card>
            <tidy-row>
              <ion-skeleton-text animated="true" style="width: 80%; height: 16px" />
            </tidy-row>
            <tidy-row>
              <ion-skeleton-text animated="true" style="width: 24%" />
            </tidy-row>
          </tidy-card>
          <tidy-card>
            <tidy-row>
              <ion-skeleton-text animated="true" style="width: 27%; height: 16px" />
            </tidy-row>
            <tidy-row>
              <ion-skeleton-text animated="true" style="width: 24%" />
            </tidy-row>
          </tidy-card>
          <tidy-card>
            <tidy-row>
              <ion-skeleton-text animated="true" style="width: 58%; height: 16px" />
            </tidy-row>
            <tidy-row>
              <ion-skeleton-text animated="true" style="width: 24%" />
            </tidy-row>
          </tidy-card>
          <tidy-card>
            <tidy-row>
              <ion-skeleton-text animated="true" style="width: 61%; height: 16px" />
            </tidy-row>
            <tidy-row>
              <ion-skeleton-text animated="true" style="width: 24%" />
            </tidy-row>
          </tidy-card>
          <tidy-card>
            <tidy-row>
              <ion-skeleton-text animated="true" style="width: 44%; height: 16px" />
            </tidy-row>
            <tidy-row>
              <ion-skeleton-text animated="true" style="width: 24%" />
            </tidy-row>
          </tidy-card>
          <tidy-card>
            <tidy-row>
              <ion-skeleton-text animated="true" style="width: 76%; height: 16px" />
            </tidy-row>
            <tidy-row>
              <ion-skeleton-text animated="true" style="width: 24%" />
            </tidy-row>
          </tidy-card>
          <tidy-card>
            <tidy-row>
              <ion-skeleton-text animated="true" style="width: 40%; height: 16px" />
            </tidy-row>
            <tidy-row>
              <ion-skeleton-text animated="true" style="width: 24%" />
            </tidy-row>
          </tidy-card>
        }

      </tidy-wrapper>
    </ng-template>

    @if (!isRightSideContent) {
      <app-scroll-wrapper [templateContent]="content" />
    }

    @if (isRightSideContent) {
      <ion-content class="ion-content-right-column">
        <ng-container *ngTemplateOutlet="content" />
      </ion-content>
    }

    @if (loaded) {
      <tidy-fab [isRightSidePanelButton]="isRightSideContent">
        <tidy-fab-button class="main-btn">
          <tidy-image src="assets/svg/add-heavy.svg" class="large-body-size" />
          <tidy-text largeBody="Add" class="white" />
        </tidy-fab-button>
        <tidy-fab-list>
          <tidy-fab-button
            (click)="goToAddToDo()">
            <tidy-image [src]="'assets/svg/add-heavy.svg'" class="large-body-size" />
            <tidy-text largeBody="Checklist Item" class="white" />
          </tidy-fab-button>
          <tidy-fab-button
            (click)="takeRoomPhoto()">
            <tidy-image [src]="'assets/svg/add-heavy.svg'" class="large-body-size" />
            <tidy-text largeBody="Photo" class="white" />
          </tidy-fab-button>
        </tidy-fab-list>
      </tidy-fab>
    }
